import { gql } from '@apollo/client';
import {
    DashboardTableExportInput,
} from '../../../../../../graphql/mutations/dashboard/generateDashboardTableExport';

export const GENERATE_DSP_DELIVERY_COMPLETED_SUMMARY_TABLE_EXPORT = gql`
    mutation GenerateDspDeliveryCompletedSummaryTableExport($input: DashboardTableExportInput!) {
        generateDspDeliveryCompletedSummaryTableExport(input: $input)
    }
`;

export interface GenerateDspDeliveryCompletedSummaryTableExportResponse {
    generateDspDeliveryCompletedSummaryTableExport: string;
}

export interface GenerateDspDeliveryCompletedSummaryTableExportVariables {
    input: DashboardTableExportInput;
}
